import { Stack, Typography } from "@mui/material";
import { Fragment } from "react"


export const EstimateMessageBill = ({ status, characteristics }) => {
    const changeLineToLine = characteristics?.split(/\r\n|\r|\n/, -1);
    return (
        <div>
            {
                (statusEstimate.includes(status))
                    ?
                    <Stack>
                        <Typography textAlign='center' variant='subtitle1'><b>CARACTERÍSTICAS</b></Typography>
                        {/* <Typography textAlign='center' variant='caption' mt='0.5rem'>{characteristicText +' ' + characteristics}</Typography> */}
                        <Typography textAlign='center' variant='caption' mt='0.5rem'>{characteristicText}</Typography>
                        {changeLineToLine.map((line, i) => <Typography textAlign='center' key={i} variant='caption' mt='0.5rem'>{line}</Typography>)}
                    </Stack>
                    :
                    <Fragment>
                        <p>Estimados Señores/as:</p>
                        <p>A continuación detallamos trabajos realizados, tiempos de alquiler e importaciones correspondientes al periodo detallado, de los cuales pasamos a emitir la correspondiente factura.</p>
                        <p style={{ marginLeft: '10rem' }}>Atentamente, queda a su entera disposición</p>
                        <p style={{ marginLeft: '15rem' }}><b>ANIBER ANDAMIOS S.L.</b></p>
                    </Fragment>
            }
        </div>
    )
}

const statusEstimate = ['Provisional', 'Definitivo', 'Aceptado'];
const characteristicText = "Colocación de andamio tipo europeo conforme normativa (UNE EN 12810-11).";